<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <search-item
          config-module="20240301"
          :reset="true"
          :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
          :auto-init="searchItemAutoInit"
          :custom-search-items="customSearchItems"
          @click-more="value=>isAdvancedQuery=value"
          @simSearchItemCallBack="toSimpleQuery"
          @advSearchItemCallBack="toAdvancedQuery"
        >
          <div slot="operations">
            <el-button v-if="checkPermission(['button_SupplierCharge_confirmCharge'])" no="button1" type="primary" @click="toPassChargeSyncOut()">{{ $t('SeaExport.confirmCharge') }}</el-button>
            <el-button v-if="checkPermission(['button_SupplierCharge_refuseCharge'])" no="button2" type="danger" @click="toNotPassChargeSyncOut()">{{ $t('SeaExport.Refuse') }}</el-button>
            <el-button no="button3" type="primary" @click="toRefresh()">{{ $t('SeaExport.Refresh') }}</el-button>
            <el-button no="button4" type="primary" @click="toManualMatching">{{ $t('Clearing.ManualMatching') }}</el-button>
          </div>
        </search-item>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="2024030101"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <div :class="['fixedBottom']" class="total-wrapper">
            <!-- <span v-show="showCount">
              {{ this.$t('SeaExport.Select') + ' ' + selectionCount + ':' }}
            </span>
            <div style="display: flex;align-content: center;padding-left: 5px;">
              <span style="font-weight: bold;font-size: 13px;">{{ $t('CargoMsg.Cargo_ReceivableToCNY') }}</span>
              <span >{{receivable}}</span>
            </div>
            <div style="display: flex;align-content: center;padding-left: 5px;">
              <span style="font-weight: bold;font-size: 13px;">{{ $t('CargoMsg.Cargo_DuesToCNY') }}</span>
              <span >{{dues}}</span>
            </div>
            <div style="display: flex;align-content: center;padding-left: 5px;">
              <span style="font-weight: bold;font-size: 13px;">{{ $t('CargoMsg.Cargo_EquivalentCNY') }}</span>
              <span >{{amountTo}}</span>
            </div>
            <charge-count-group
              :data-provider="selectedRows"
              :data-field="'amount'"
              :display-and-count-field-list="displayAndCountFieldList"
              :always-show="true"
            /> -->
            <charge-currency-total-group
              ar-field="receivable"
              currency-field="currency"
              data-field="amount"
              :data-provider="selectedRows.length > 0 ? selectedRows : rowData"
              :ar-label="$t('Message.Receivable')"
              :ap-label="$t('Message.Payable')"
            />
          </div>
          <cargo-pagination
            config-module="990010"
            :total="total"
            :page-count="pageCount"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQueryByPage"
          />
        </div>
        <!--拒绝-->
        <reject-dialog
          v-if="rejectWindow.visible"
          :visible.sync="rejectWindow.visible"
          :job-no="rejectWindow.jobNo"
          :reject-call-back="rejectWindow.rejectCallBack"
          :append-to-body="true"
        />
      </div>
    </div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="matchDialog.visible"
      :title="$t('Clearing.SelectBusinessNumber')"
      width="1000px"
      :close-on-click-modal="false"
    >
      <div style="display: flex;flex-direction: column">
        <el-form label-width="60px" inline label-position="left" style="margin-left: 20px;">
          <template v-if="matchDialog.type===0">
            <el-form-item :label="$t('queryJob.containerNo')">
              <el-input v-model="matchDialog.supplierOrderNo" disabled style="width: 200px" />
            </el-form-item>
          </template>
          <template v-else-if="matchDialog.type===1">
            <el-form-item :label="$t('queryJob.warehouseNo')">
              <el-input v-model="matchDialog.supplierOrderNo" disabled style="width: 200px" />
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item :label="$t('queryJob.businessNumber')">
              <el-input v-model="matchDialog.jobNo" style="width: 200px" />
            </el-form-item>
            <el-form-item :label="$t('queryJob.mblNo')">
              <el-input v-model="matchDialog.mbl" style="width: 200px" />
            </el-form-item>
            <el-form-item label="SO NO.">
              <el-input v-model="matchDialog.soNo" style="width: 200px" />
            </el-form-item>
          </template>
        </el-form>
        <div style="margin-top: 5px;">
          <el-button type="primary" :style="{width:'100px',marginLeft:'20px'}" @click="toQueryJob">{{ $t('queryJob.Search') }}</el-button>
          <el-radio-group v-model="matchDialog.type" style="float: right;margin-top: 15px;margin-right: 20px;" @change="onTypeChange">
            <el-radio ref="boxNo" :label="0">{{ $t('Clearing.ManualMatchByBoxNo') }}</el-radio>
            <el-radio ref="warehouseNo" :label="1">{{ $t('Clearing.ManualMatchByWarehouseNo') }}</el-radio>
            <el-radio :label="2">{{ $t('Clearing.FreeMatch') }}</el-radio>
          </el-radio-group>
        </div>
        <cargo-ag-grid
          config-module="2024030102"
          :grid-options="matchDialog.gridOptions"
          :column-defs="matchDialog.columnDefs"
          :row-data="matchDialog.rowData"
          style="padding: 15px 20px 10px 20px;"
        />
      </div>
      <div slot="footer">
        <el-button type="primary" style="width: 100px;" @click="saveJobNo">{{ $t('Message.Confirm') }}</el-button>
        <el-button style="width: 100px;" @click="matchDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 组件样式模板（用于嵌入ag-grid）-->
    <div v-show="false">
      <el-radio-group :value="1">
        <el-radio ref="trueRadioTemplate" :label="1" />
        <el-radio ref="falseRadioTemplate" :label="0" />
      </el-radio-group>
    </div>
  </div>
</template>

<script>

import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cache, cacheName } from '@/utils/cacheManager'
import { supplierChargeAdvancedSearch, notPassChargeSyncOut, passChargeSyncOut, outChargeMatchJob, outChargeUpdateJob } from '@/api/clearing/chargeConfirmed'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import $store from '@/store'
import rejectDialog from '@/views/cargo/v0/AirExport/components/verify/rejectDialog.vue'
import checkPermission from '@/utils/permission'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { queryJobByContainerNo, queryJobByManualMatch } from '@/api/booking/job'
import ChargeCountGroup from '@/components/Cargo/Act/chargeSummary/ChargeCountGroup.vue'
import ChargeCurrencyTotalGroup from './ChargeCurrencyTotalGroup'
import ChargeCountField from '@/components/Cargo/Act/chargeSummary/ChargeCountField'
import ChargeCountManager from '@/components/Cargo/Act/chargeSummary/ChargeCountManager'
import ChargeCountDataAdapte from '@/components/Cargo/Act/chargeSummary/ChargeCountDataAdapte'
import ChargeGroupCounter from '@/components/Cargo/Act/chargeSummary/ChargeGroupCounter'

export default {
  name: 'SupplierCharge',
  components: { rejectDialog, searchItem, ChargeCountGroup, ChargeCurrencyTotalGroup },
  data() {
    return {
      loading: false,
      isAdvancedQuery: false, // 记录上一次操作是否为高级查询
      SystemConstants,
      rowData: [],
      selectedRows: [],
      showCount: false,
      gridApi: null,
      total: 0,
      pageCount: 0,
      searchItemAutoInit: true,
      customSearchItems: [], // 自定义高级查询项
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择
        context: { componentParent: this },
        onSelectionChanged: this.filterChange
      },
      filter: {
        conditions: {},
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      filterJson: {
        jobNo: '',
        page: 1,
        branchId: 0, // 分公司ID
        conditions: [], // 查询条件
        snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
        noUserChargeRole: false, // 是查看无主费用权限
        allChargeRole: false // 是查看所有费用权限
      },
      rejectWindow: {
        visible: false,
        jobNo: null,
        rejectCallBack: null
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('SeaExport.source'),
          colId: 'pushSource',
          field: 'pushSource',
          width: 180,
          cellRenderer: params => {
            return ColumnUtils.chargeConfirmSourceOutLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.pushTime'),
          colId: 'pushTime',
          field: 'pushTime',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.supplierOrderNo'),
          colId: 'supplierOrderNo',
          field: 'supplierOrderNo',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 180
        },
        {
          headerName: 'SO No.',
          colId: 'soNo',
          field: 'soNo',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.WarehouseNo'),
          colId: 'warehouseNo',
          field: 'warehouseNo',
          width: 180
        },
        {
          headerName: 'HBL No.',
          colId: 'hblNo',
          field: 'hblNo',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.supplierName'),
          colId: 'supplierName',
          field: 'supplierName',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.supplierMatchName'),
          colId: 'supplierId',
          field: 'supplierId',
          width: 180,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_taxIncludedPrice'),
          colId: 'amount',
          field: 'amount',
          width: 180,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_unitPrice'),
          colId: 'taxUnitPrice',
          field: 'taxUnitPrice',
          width: 180,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000')
          }
        },
        {
          headerName: this.$t('FinanceManage.adChargeInfo_quantity'),
          colId: 'quantity',
          field: 'quantity',
          width: 180,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_exchangeRate'),
          colId: 'exchangeRate',
          field: 'exchangeRate',
          width: 180,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000000')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_taxRate'),
          colId: 'taxRate',
          field: 'taxRate',
          width: 180,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_chargeItem'),
          colId: 'supplierChargeItemId',
          field: 'supplierChargeItemId',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.chargeItemLocal'),
          colId: 'chargeItemId',
          field: 'chargeItemId',
          width: 180,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        },
        {
          headerName: this.$t('FinanceManage.currency'),
          colId: 'currency',
          field: 'currency',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.refMsg1'),
          colId: 'refMsg1',
          field: 'refMsg1',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.refMsg2'),
          colId: 'refMsg2',
          field: 'refMsg2',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.supportNo'),
          colId: 'refNo',
          field: 'refNo',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.Remarks'),
          colId: 'remark',
          field: 'remark',
          width: 180
        },
        {
          headerName: this.$t('Clearing.ConfirmationStatus'),
          colId: 'chargeConfirmState',
          field: 'chargeConfirmState',
          width: 180,
          cellRenderer: params => {
            return ColumnUtils.chargeConfirmStateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.auditOperationTime'),
          colId: 'verifiedTime',
          field: 'verifiedTime',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.AuditOperator'),
          field: 'verifiedBy',
          colId: 'verifiedBy',
          width: 80,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DenialReason'),
          colId: 'rejectReason',
          field: 'rejectReason',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.ReceivingBranch'),
          colId: 'branchName',
          field: 'branchName',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.ReceivingMatchBranch'),
          field: 'branchId',
          colId: 'branchId',
          width: 80,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ARAP'),
          field: 'receivable',
          colId: 'receivable',
          width: 80,
          cellRenderer: (params) => {
            return ColumnUtils.arApLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Operation'),
          field: 'op',
          colId: 'op',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_op')
          },
          hide: true,
          width: 180
        },
        {
          headerName: this.$t('SeaExport.Vessel'),
          field: 'vessel',
          colId: 'vessel',
          hide: true,
          width: 180
        },
        {
          headerName: this.$t('SeaExport.Voyage'),
          field: 'voyageFlight',
          colId: 'voyageFlight',
          hide: true,
          width: 180
        },
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNos',
          colId: 'containerNos',
          hide: true,
          width: 150
        }
      ],
      chargeSyncCheckJobState: null,
      privilege: {
        userChargeRole: false,
        branchChargeRole: false,
        departmentChargeRole: false,
        allChargeRole: false,
        noUserChargeRole: false
      },
      matchDialog: {
        visible: false,
        keys: [],
        type: 0,
        supplierOrderNo: '',
        jobNo: '',
        mbl: '',
        soNo: '',
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          context: { componentParent: this }
        },
        columnDefs: [
          {
            headerName: '',
            field: 'checked',
            width: 70,
            suppressMenu: true,
            resizable: false,
            suppressSizeToFit: true,
            sortable: false,
            cellRenderer: params => {
              if (params.data.checked) {
                return `
                <label class="el-radio is-checked">
                  <span class="el-radio__input is-checked">
                    <span class="el-radio__inner" />
                  </span>
                </label>`
              } else {
                return `
                <label class="el-radio">
                  <span class="el-radio__input">
                    <span class="el-radio__inner" />
                  </span>
                </label>`
              }
            },
            onCellClicked: params => {
              const checked = !params.data.checked
              // 重置所有选中
              if (checked) {
                this.matchDialog.rowData.forEach(item => {
                  item.checked = false
                })
              }
              params.data.checked = checked
              params.api.refreshCells({ force: true })
            }
          },
          {
            headerName: this.$t('SeaExport.BusinessNo'),
            field: 'jobNo',
            width: 100
          },
          {
            headerName: this.$t('queryJob.consignationCompany'),
            field: 'customerId',
            width: 150,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          {
            headerName: 'ETD',
            field: 'etd',
            width: 100,
            valueFormatter: params => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.Vessel'),
            field: 'vessel',
            width: 100
          }, {
            headerName: this.$t('SeaExport.Voyage'),
            field: 'voyageFlight',
            width: 100
          },
          {
            headerName: 'SO No.',
            field: 'soNo',
            width: 100
          },
          {
            headerName: 'HBL No.',
            field: 'hblNo',
            width: 100
          }
        ],
        rowData: []
      },
      selectionCount: 0,
      receivable: 0.00,
      dues: 0.00,
      amountTo: 0.00,
      displayAndCountFieldList: [
        new ChargeCountField(this.$t('CargoMsg.Cargo_Receivable'),
          'amount', 'currency', 'exchangeRate', ChargeCountManager.DISP_IN_GRID, [
            new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'receivable', ChargeGroupCounter.OPERATOR_EQUAL, true)
          ]),
        new ChargeCountField(this.$t('CargoMsg.Cargo_DuesP'),
          'amount', 'currency', 'exchangeRate', ChargeCountManager.DISP_IN_GRID, [
            new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'receivable', ChargeGroupCounter.OPERATOR_EQUAL, false)
          ]),
        new ChargeCountField(this.$t('CargoMsg.Cargo_AmountTo'),
          'totalAmount', 'currency', 'exchangeRate', ChargeCountManager.DISP_IN_GRID, [
            new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'totalAmount')
          ])
      ]
    }
  },
  async created() {
    await cache.load(cacheName.OFFICE, cacheName.CONFIG)
    this.initSearchItems()
    this.initConfig()
  },
  methods: {
    checkPermission,
    initConfig() {
      this.privilege.allChargeRole = checkPermission(['role_SupplierCharge_allCharge'])
      this.privilege.noUserChargeRole = checkPermission(['role_SupplierCharge_noUserCharge'])
      const chargeSyncCheckJobStateTxt = cache.config.get('ChargeSyncCheckJobState')
      const checkJobStates = []
      if (chargeSyncCheckJobStateTxt) {
        const jobStateStrs = chargeSyncCheckJobStateTxt.split(',')
        for (const jobStateStr of jobStateStrs) {
          switch (jobStateStr.trim()) {
            case '0': // 正操作
              checkJobStates.push(0)
              break
            case '1': // 已提交
              checkJobStates.push(1)
              break
            case '2': // 已审核
              checkJobStates.push(2)
              break
            case '11': // 预提交
              checkJobStates.push(11)
              break
          }
        }
      }
      this.chargeSyncCheckJobState = checkJobStates.length > 0 ? checkJobStates : null
    },
    // 分页查询
    toQueryByPage() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery(this.filterJson.jobNo)
      }
    },
    // 简单查询
    toSimpleQuery(keyword) {
      this.filter.pageNum = 1
      this.filterJson.jobNo = keyword.trim()
      this.filterJson.conditions = []
      this.doAdvancedQuery()
    },
    // 高级查询
    toAdvancedQuery(data) {
      // 高级查询条件组装
      if (typeof data !== 'undefined') {
        this.filter.pageNum = 1
        this.filterJson.jobNo = ''
      }
      this.doAdvancedQuery(data)
    },
    doAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        this.filterJson.conditions = data
      }
      this.loading = getLoading()
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = $store.getters.currentOfficeId
      this.filterJson.noUserChargeRole = this.privilege.noUserChargeRole
      this.filterJson.allChargeRole = this.privilege.allChargeRole
      supplierChargeAdvancedSearch(this.filterJson).then(res => {
        this.handleQueryData(res)
      }).catch((err) => {
        this.$message.error(err)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 审核通过
    toPassChargeSyncOut() {
      const selectedRows = this.gridApi.getSelectedRows()
      if (!(selectedRows.length > 0)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      if (this.chargeSyncCheckJobState) {
        for (const row of selectedRows) {
          if (!this.chargeSyncCheckJobState.includes(row.jobState)) {
            this.$message.warning(this.$t('Message.ChargeSyncJobStateCheckFail'))
            return
          }
        }
      } else {
        for (const row of selectedRows) {
          if (row.jobState !== 0) {
            this.$message.warning(this.$t('FinanceManage.businessHasBeenSubmitted'))
            return
          }
        }
      }
      for (const row of selectedRows) {
        if (!row.jobNo) {
          this.$message.warning(this.$t('SeaExport.NoJobMatch'))
        }
        if (!row.supplierId || !row.chargeItemId) {
          this.$message.warning(this.$t('SeaExport.PleaseRefreshThePage'))
          return
        }
        if (!row.businessDate) {
          this.$message.warning(this.$t('SeaExport.BusinessDateIsNull'))
          return
        }
      }
      if (!this.checkConfirmedData()) {
        return
      }
      this.$confirm(this.$t('SeaExport.ConfirmReceiveTheseCharges'), this.$t('Message.Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
        cancelButtonText: this.$t('CargoMsg.Cargo_No'),
        type: 'info'
      }).then(() => {
        const loading = getLoading4Cxt(this)
        passChargeSyncOut(selectedRows).then(res => {
          this.$message.success(this.$t('Message.OperationSuccessfully'))
          this.toQueryByPage()
        }).finally(() => {
          if (loading) {
            loading.close()
          }
        })
      }).catch(() => {
      })
    },
    // 审核不通过
    toNotPassChargeSyncOut() {
      if (!this.checkConfirmedData()) {
        return
      }
      this.rejectWindow.rejectCallBack = this.rejectFunc
      this.rejectWindow.visible = true
    },
    rejectFunc(reason) {
      if (!reason) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ReasonNotEntered'))
        return false
      }
      const selectedRows = this.gridApi.getSelectedRows()
      const keys = Array.from(selectedRows, p => p.uuid)
      const loading = getLoading4Cxt(this)
      notPassChargeSyncOut(keys, { reason: reason }).then(res => {
        this.$message.success(this.$t('Message.OperationSuccessfully'))
        this.toQueryByPage()
      }).finally(() => {
        if (loading) {
          loading.close()
        }
      })
    },
    initSearchItems() {
      this.searchItemAutoInit = true
      return this.customSearchItems
    },
    handleQueryData(res) {
      this.rowData = res.data.list
      this.total = Number(res.data.total)
      this.pageCount = res.data.pages
      this.filterChange2()
    },
    checkConfirmedData() {
      const selectedRows = this.gridApi.getSelectedRows()
      const keys = []
      let flag = selectedRows.length > 0
      if (flag) {
        for (const row of selectedRows) {
          if (row.chargeConfirmState !== SystemConstants.WAITING_CONFIRMATION_OUT.code) {
            flag = false
            break
          }
          keys.push(row.uuid)
        }
      }
      if (flag) {
        flag = keys.length > 0
      }
      if (!flag) {
        this.$message.warning(this.$t('SeaExport.selectBeConfirmedCharge'))
      }
      return flag
    },
    // 重新匹配外部推送费用关联的业务
    toRefresh() {
      const selectedRows = this.gridApi.getSelectedRows()
      if (!(selectedRows.length > 0)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      const loading = getLoading4Cxt(this)
      const keys = Array.from(selectedRows, p => p.uuid)
      outChargeMatchJob(keys).then(res => {
        this.$message.success(this.$t('SeaExport.RefreshSuccessfulRows', [res.data]))
        this.toQueryByPage()
      }).finally(() => {
        if (loading) {
          loading.close()
        }
      })
    },
    // 人工匹配
    toManualMatching() {
      const selectedRows = this.gridApi.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      const keys = []
      const supplierOrderNo = selectedRows[0].supplierOrderNo
      for (const row of selectedRows) {
        if (row.chargeConfirmState !== SystemConstants.WAITING_CONFIRMATION_OUT.code) {
          this.$message.warning(this.$t('SeaExport.selectBeConfirmedCharge'))
          return
        }
        if (row.supplierOrderNo !== supplierOrderNo) {
          this.$message.warning(this.$t('Clearing.SelectSameSupplierNumberMatch'))
          return
        }
        keys.push(row.uuid)
      }
      this.matchDialog.keys = keys
      this.matchDialog.type = 0
      this.matchDialog.supplierOrderNo = supplierOrderNo
      this.matchDialog.jobNo = ''
      this.matchDialog.mbl = ''
      this.matchDialog.soNo = ''
      this.matchDialog.rowData = []
      this.matchDialog.visible = true
      this.toQueryJob()
    },
    async toQueryJob() {
      let res = null
      if (this.matchDialog.type === 0) {
        res = await queryJobByContainerNo({ containerNo: this.matchDialog.supplierOrderNo, branchId: this.filterJson.branchId })
      } else if (this.matchDialog.type === 1) {
        res = await queryJobByManualMatch({ warehouseNo: this.matchDialog.supplierOrderNo, branchId: this.filterJson.branchId })
      } else {
        const params = { jobNo: this.matchDialog.jobNo.trim(), mbl: this.matchDialog.mbl, soNo: this.matchDialog.soNo, branchId: this.filterJson.branchId }
        if (!params.jobNo && !params.mbl && !params.soNo) {
          this.$message.warning(this.$t('Clearing.BusinessNoMblSoNoNotEmpty'))
          return
        }
        res = await queryJobByManualMatch(params)
      }
      for (const item of res.data) {
        item.checked = false
      }
      this.matchDialog.rowData = res.data
    },
    saveJobNo() {
      const job = this.matchDialog.rowData.find(p => p.checked)
      if (!job) {
        this.$message.warning(this.$t('Clearing.SelectCorrespondeBusiness'))
        return
      }
      const loading = getLoading4Cxt(this)
      outChargeUpdateJob({ keys: this.matchDialog.keys.join(','), jobUuid: job.uuid }).then(res => {
        loading.close()
        this.$message.success(this.$t('SystemMaintenance.UpdateSuccessful'))
        this.matchDialog.visible = false
        this.toQueryByPage()
      }).catch(() => {
        loading.close()
      })
    },
    onTypeChange() {
      this.matchDialog.rowData = []
    },
    filterChange() {
      this.showCount = true
      let selectedRows = this.gridApi.getSelectedRows()
      if (!selectedRows || selectedRows.length === 0) {
        selectedRows = this.rowData
        this.showCount = false
      }
      if (selectedRows) {
        this.selectedRows = JSON.parse(JSON.stringify(selectedRows))
        for (const row of this.selectedRows) {
          row.totalAmount = row.receivable ? row.amount : -row.amount
        }
        this.selectionCount = selectedRows.length
        const receivableData = selectedRows.filter(item => item.receivable)
        if (receivableData) {
          this.receivable = receivableData.reduce((accumulator, currentValue) => accumulator + (currentValue.amount * currentValue.exchangeRate), 0).toFixed(2)
        }
        const duesData = selectedRows.filter(item => !item.receivable)
        if (duesData) {
          this.dues = duesData.reduce((accumulator, currentValue) => accumulator + (currentValue.amount * currentValue.exchangeRate), 0).toFixed(2)
        }
        this.amountTo = (this.receivable - this.dues).toFixed(2)
      }
    },
    filterChange2() {
      this.showCount = false
      const selectedRows = this.rowData
      if (selectedRows) {
        this.selectedRows = JSON.parse(JSON.stringify(selectedRows))
        for (const row of this.selectedRows) {
          row.totalAmount = row.receivable ? row.amount : -row.amount
        }
        this.selectionCount = selectedRows.length
        const receivableData = selectedRows.filter(item => item.receivable)
        if (receivableData) {
          this.receivable = receivableData.reduce((accumulator, currentValue) => accumulator + (currentValue.amount * currentValue.exchangeRate), 0).toFixed(2)
        }
        const duesData = selectedRows.filter(item => !item.receivable)
        if (duesData) {
          this.dues = duesData.reduce((accumulator, currentValue) => accumulator + (currentValue.amount * currentValue.exchangeRate), 0).toFixed(2)
        }
        this.amountTo = (this.receivable - this.dues).toFixed(2)
      }
    }
  }
}
</script>
